import React from 'react';
import PageHeader from '../../components/PageHeader';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const LindaBoes = () => {
  return (
    <div className="w-full bg-brand-light min-h-screen">
      <PageHeader 
        title="Linda Boes" 
        description="CEO & Consultant | MS Industrial Psychology" 
      />

      <section className="py-20 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 sticky top-28">
              <div className="aspect-square rounded-xl overflow-hidden mb-6 border-4 border-slate-50 shadow-inner bg-slate-100">
                <img src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1784999355069-blob" alt="Linda Boes" className="w-full h-full object-cover object-top" />
              </div>
              <h3 className="font-bold text-brand-navy mb-4 border-b border-slate-100 pb-2">Credentials</h3>
              <ul className="space-y-3 text-sm text-slate-700 font-medium">
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiBookOpen} className="text-brand-navy" /> MS in Industrial Psychology</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiBookOpen} className="text-brand-navy" /> BS in Organizational Management</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiBookOpen} className="text-brand-navy" /> AA in Professional Writing</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiAward} className="text-brand-green" /> EQ-i 2.0 & EQ 360 Practitioner</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiAward} className="text-brand-green" /> ILM Certification (Leadership/Mgmt)</li>
                <li className="flex items-center gap-2"><SafeIcon icon={FiIcons.FiAward} className="text-brand-green" /> CPLP (Assoc. for Talent Development)</li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-8 prose prose-slate prose-lg">
            <p>
              As the CEO of Boes & Boes, Linda Boes is a talent-development, leadership, and organizational-development specialist known for creating meaningful and memorable learning experiences. She understands that the success of any emergency system or organizational objective relies entirely on the capability and confidence of the people executing it.
            </p>

            <h3 className="text-brand-navy font-bold">Organizational Leadership & Talent Development</h3>
            <p>
              Linda specializes in aligning human performance with strategic business goals. Her deep expertise in industrial psychology allows her to design programs that drive genuine behavioral change rather than just checking a training box. Her core focus areas include:
            </p>
            <div className="grid sm:grid-cols-2 gap-x-4">
              <ul>
                <li>Executive and leadership coaching</li>
                <li>Leadership academy design & delivery</li>
                <li>Psychometric/personality assessments</li>
                <li>Employee evaluation systems</li>
              </ul>
              <ul>
                <li>Career and talent development</li>
                <li>Strategic-plan development</li>
                <li>Employee KPI development</li>
                <li>Change leadership</li>
              </ul>
            </div>

            <h3 className="text-brand-navy font-bold">Client Impact</h3>
            <p>
              Linda has successfully delivered complex organizational development initiatives for Fortune 100 companies, large industrial employers, and nonprofit organizations. Her approach ensures that leaders are equipped to handle not just daily operational demands, but the high-stress environments generated during organizational pivots or crisis events.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LindaBoes;